import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE, LockIcon } from 'components/UI'
// context
import { DataHubAPIContext } from 'containers/DataHub/layers/API'
// hooks
import { useCurrentUser } from 'hooks/index'

const RefreshDatasetsButton: React.FC = () => {
  const { refreshDatasets } = React.useContext(DataHubAPIContext)

  const {
    permissionsFromSecurityGroups: { reportingRefresh }
  } = useCurrentUser()

  return (
    <Button
      style={CREATE_BUTTON_STYLE}
      layout={BUTTON_LAYOUTS.PURPLE}
      disabled={!reportingRefresh}
      onClick={refreshDatasets}
    >
      Refresh Datasets {!reportingRefresh && <LockIcon />}
    </Button>
  )
}

export default RefreshDatasetsButton
